<h2 mat-dialog-title>{{ action === 'edit' ? 'Edit' : 'Upload' }} Template File</h2>
<mat-dialog-content class="mat-typography">
  <div class="container">
    <app-form-builder [formFields]="formFields" [(formGroup)]="userForm"></app-form-builder>
    <app-file-upload [(uploadSummary)]="uploadSummary"></app-file-upload>
    <div *ngIf="fileRequiredMissing" class="file-required-error">
      A file is required to create a template.
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close [disabled]="submitting">Cancel</button>
  <button mat-raised-button color="primary" (click)="submit()" [disabled]="!userForm.valid || fileRequiredMissing || submitting">
    {{ submitting ? 'Submitting...' : 'Submit' }}
  </button>
</mat-dialog-actions>
